"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listNovoDark = exports.listNovo = exports.list = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const list = {
    listPadding: '0',
    listMargin: '0',
    listStyle: 'none',
    listGroupBorderColor: color_const_1.default.cloudyBlue300,
    listBackground: '#FFF',
    listMaxWidth: '100%',
    listItemFontFamily: font_const_1.default.family,
    listItemFontSize: font_const_1.default.sizeSm,
    listItemFontWeight: font_const_1.default.weightDefault,
    listItemLineHeight: font_const_1.default.lineHeightSm,
    listItemPadding: `2px ${size_const_1.default.default}`,
    listItemColor: color_const_1.default.pickledBluewood800,
    listItemActiveTextDecoration: 'none',
    listItemColorActive: color_const_1.default.dodgerBlue,
    listItemColorDisabled: color_const_1.default.steel700,
    listItemHoverColor: undefined,
    isClassic: true,
    listItemFocusBorderColor: color_const_1.default.dodgerBlue,
    listItemActiveBackgroundColor: color_const_1.default.gray10,
};
exports.list = list;
const listNovo = {
    isClassic: false,
    // Typography
    ...novo.body02,
    listItemFontFamily: undefined,
    listItemFontSize: undefined,
    listItemFontWeight: undefined,
    listItemLineHeight: undefined,
    // Structure
    listPadding: '0',
    listItemPadding: `${novo.spacing03} ${novo.spacing05}`,
    listMargin: '0',
    listMaxWidth: '100%',
    listStyle: 'none',
    listItemActiveTextDecoration: 'none',
    // Color
    listGroupBorderColor: novo.ui01,
    listBackground: novo.ui06,
    listItemColor: novo.textColor01,
    listItemColorActive: undefined,
    listItemHoverColor: novo.hover08,
    listItemColorDisabled: novo.disabled01,
    listItemFocusBorderColor: novo.focus01,
    listItemActiveBackgroundColor: novo.active05,
};
exports.listNovo = listNovo;
const listNovoDark = {
    ...listNovo,
    listGroupBorderColor: novoDark.ui01,
    listBackground: novoDark.ui06,
    listItemColor: novoDark.textColor01,
    listItemColorActive: undefined,
    listItemActiveBackgroundColor: novoDark.active05,
    listItemHoverColor: novoDark.hover05,
    listItemColorDisabled: novoDark.disabled01,
    listItemFocusBorderColor: novoDark.focus01,
};
exports.listNovoDark = listNovoDark;
